import { DirectoryScreen } from '@/components/seo/directory-screen';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';

/** `/profissionais/[categoria]/[cidade]` — cidade no formato `sao-paulo-sp`. */
export default function CityDirectoryRoute() {
  const { categoria, cidade } = useLocalSearchParams<{ categoria: string; cidade: string }>();
  return <DirectoryScreen categorySlug={String(categoria ?? '')} city={String(cidade ?? '')} />;
}
